/* MQA float-frame shadow enhancer — FINAL.
   Per-finish recessed channel + soft cast shadow around FLOAT frames only.
   Non-invasive: appends to the rendered SVG; never touches cart/properties/sync. */
(function () {
  var GAP_RATIO = 0.42;   // reveal channel width vs frame face (tunable)
  var SH_OP     = 0.5;    // cast-shadow strength (tunable)
  var NS = 'http://www.w3.org/2000/svg';

  // Per-finish recess colours (edit these to tune each finish's channel)
  function recessFor(href) {
    href = (href || '').toLowerCase();
    if (/gold|gilt|brass/.test(href))              return '#524226';
    if (/black|matte|noir|onyx/.test(href))        return '#070606';
    if (/white|gallery|ivory/.test(href))          return '#85857eff';
    if (/espresso|walnut|dark|brown/.test(href))   return '#201b1a';
    if (/natural|oak|wood|light|maple/.test(href)) return '#514031';
    return '#2a2018';
  }

  function num(v) { return parseFloat(v) || 0; }

  function isFloatSelected() {
    var fv = document.querySelector('.product-option[data-type="frames"] .product-option-value');
    return !!fv && /float/i.test(fv.textContent);
  }

  function enhance(svg) {
    if (!svg || svg.dataset.mqaFloat) return;
    var frameClip = svg.querySelector('clipPath[id^="frame-top-"]');
    if (!frameClip) return;
    if (svg.querySelector('clipPath[id^="mat-top-"]')) return;
    if (!isFloatSelected()) return;                       // FLOAT frames only
    var poly = frameClip.querySelector('polygon');
    if (!poly) return;
    var pts = (poly.getAttribute('points') || '').trim().split(/\s+/);
    if (pts.length < 4) return;
    var fw = num(pts[2].split(',')[1]) || num(pts[3].split(',')[0]);
    if (!(fw > 0)) return;

    var vb = svg.viewBox && svg.viewBox.baseVal;
    var parts = (svg.getAttribute('viewBox') || '').split(/\s+/);
    var ow = vb && vb.width  ? vb.width  : num(parts[2]);
    var oh = vb && vb.height ? vb.height : num(parts[3]);
    if (!(ow > 0 && oh > 0) || fw > ow * 0.45) return;

    svg.dataset.mqaFloat = '1';

    var frameImg = svg.querySelector('image[id^="img-top-"],image[id^="img-bottom-"],image[id^="img-left-"],image[id^="img-right-"]');
    var href = frameImg ? (frameImg.getAttribute('href') || frameImg.getAttribute('xlink:href') || '') : '';
    var RECESS = recessFor(href);

    var x0 = fw, y0 = fw, openW = ow - 2 * fw, openH = oh - 2 * fw;
    var g = Math.min(fw * GAP_RATIO, openW * 0.12, openH * 0.12);
    if (!(g > 0)) return;
    var id = 'mqaf-' + Math.round(ow * 100) + '-' + Math.round(oh * 100);

    var defs = document.createElementNS(NS, 'defs');
    defs.innerHTML =
      '<filter id="' + id + '-b" x="-40%" y="-40%" width="180%" height="180%">' +
        '<feGaussianBlur stdDeviation="' + (g * 0.5).toFixed(3) + '"/></filter>' +
      '<clipPath id="' + id + '-c"><rect x="' + x0 + '" y="' + y0 +
        '" width="' + openW + '" height="' + openH + '"/></clipPath>';
    svg.appendChild(defs);

    function rc(x, y, w, h) {
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + RECESS + '"/>';
    }
    var channel =
      rc(x0, y0, openW, g) +
      rc(x0, oh - fw - g, openW, g) +
      rc(x0, y0, g, openH) +
      rc(ow - fw - g, y0, g, openH);

    var ix = x0 + g, iy = y0 + g, iw = openW - 2 * g, ih = openH - 2 * g;
    var shadow =
      '<g filter="url(#' + id + '-b)" transform="translate(0,' + (g * 0.12).toFixed(3) + ')">' +
        '<rect x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih +
        '" fill="none" stroke="#000" stroke-opacity="' + SH_OP + '" stroke-width="' + (g * 0.9).toFixed(3) + '"/></g>';

    var lip =
      '<rect x="' + x0 + '" y="' + y0 + '" width="' + openW + '" height="' + openH +
        '" fill="none" stroke="#000" stroke-opacity="0.28" stroke-width="' + (g * 0.14).toFixed(3) + '"/>';

    var grp = document.createElementNS(NS, 'g');
    grp.setAttribute('clip-path', 'url(#' + id + '-c)');
    grp.innerHTML = channel + shadow;
    svg.appendChild(grp);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var svgs = root.querySelectorAll('svg');
    for (var i = 0; i < svgs.length; i++) enhance(svgs[i]);
  }

  function boot() {
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName && n.tagName.toLowerCase() === 'svg') enhance(n);
          else scan(n);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();